import type { Key, MouseEvent } from 'react';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { EditOutlined, MoreOutlined } from '@ant-design/icons';
import { PpaTableRowType, normalizePpaTableRowAction, PpaTableRowAction } from 'types/ppa';
import type { InternalTableRecord } from '../types';

type ActionMenuCellProps = {
    record: InternalTableRecord;
    menuItems: MenuProps['items'];
    onAction: (action: string, record: InternalTableRecord) => void;
};

const ACTION_BUTTON_CLASS =
    'bg-transparent border-0 p-0 h-6 w-6 flex items-center justify-center cursor-pointer';

const SCENARIO_MENU_ICON_CLASS = 'text-[16px] text-purpleFont leading-none';

const getEditMenuItemKey = (menuItems: MenuProps['items']): Key | undefined => {
    for (const item of menuItems ?? []) {
        if (item == null || typeof item !== 'object' || !('key' in item) || item.key == null) {
            continue;
        }
        if (normalizePpaTableRowAction(String(item.key)) === PpaTableRowAction.Edit) {
            return item.key;
        }
    }
    return undefined;
};

const ActionMenuCell = ({ record, menuItems, onAction }: ActionMenuCellProps) => {
    const items = menuItems ?? [];
    if (!items.length) {
        return null;
    }

    if (record.row_type === PpaTableRowType.Scenario) {
        return (
            <Dropdown
                trigger={['click']}
                overlayClassName="price-simulator-v3-action-dropdown"
                menu={{
                    items,
                    onClick: ({ key, domEvent }) => {
                        domEvent.stopPropagation();
                        onAction(String(key), record);
                    },
                }}
            >
                <button
                    type="button"
                    className={ACTION_BUTTON_CLASS}
                    onClick={(event) => event.stopPropagation()}
                >
                    <MoreOutlined className={SCENARIO_MENU_ICON_CLASS} />
                </button>
            </Dropdown>
        );
    }

    const editItemKey = getEditMenuItemKey(items);
    if (editItemKey == null) {
        return null;
    }

    return (
        <button
            type="button"
            className={ACTION_BUTTON_CLASS}
            onClick={(event: MouseEvent) => {
                event.stopPropagation();
                onAction(String(editItemKey), record);
            }}
        >
            <EditOutlined className="text-[14px] text-fontColor/70" />
        </button>
    );
};

export default ActionMenuCell;
